var s, t;
function e() {
  if (t) return s;
  t = 1;
  return s = class {
    constructor({
      search: s,
      addressId: t,
      country: e,
      maxResults: r = 5,
      includeOnlyLocality: a,
      includeOnlyPostalCode: i
    } = {}) {
      this.result = [], this.search = s, this.addressId = t, this.country = e, this.maxResults = r, this.includeOnlyLocality = a, this.includeOnlyPostalCode = i, this.customParameters = {};
    }
    addCustomParameter(s, t) {
      this.customParameters[s] = t;
    }
  };
}
export { e as __require };